module.exports = __webpack_public_path__ + "static/instagramIcon-6877fc99e2f36909c43ed69a833e93eb.png";